import React from 'react';
import { SensorHealth } from '../../core/types/sensor';

interface DiagnosticsViewProps {
  healthA?: SensorHealth;
  healthAudio?: SensorHealth;
  actualFpsA?: number;
  actualFpsB?: number;
  audioSettings?: {
    echoCancellation?: boolean;
    autoGainControl?: boolean;
    noiseSuppression?: boolean;
  };
}

export const DiagnosticsView: React.FC<DiagnosticsViewProps> = ({
  healthA,
  healthAudio,
  actualFpsA,
  actualFpsB,
  audioSettings,
}) => {
  return (
    <div>
      <h3 style={{ fontSize: '1rem', marginBottom: 16 }}>设备与软件传感器运行状态诊断 (Sensor Health & Diagnostics)</h3>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 16 }}>
        {/* CAMERA A DIAGNOSTICS */}
        <div className="camera-card" style={{ padding: 16 }}>
          <h4 style={{ fontSize: '0.9rem', marginBottom: 12, borderBottom: '1px solid var(--border-color)', paddingBottom: 8 }}>
            📷 摄像头 A (Camera A Sensor)
          </h4>
          <div style={{ fontSize: '0.85rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div>状态: <strong>{healthA?.status || 'idle'}</strong></div>
            <div>实际帧率 (Actual FPS): <strong>{actualFpsA || 0} FPS</strong></div>
            <div>丢帧数 (Dropped Frames): <strong>{healthA?.droppedCount || 0}</strong></div>
            <div>错误数 (Error Count): <strong>{healthA?.errorCount || 0}</strong></div>
            <div>
              质量标志: {healthA?.qualityFlags.length ? healthA.qualityFlags.join(', ') : '正常 (Normal)'}
            </div>
          </div>
        </div>

        {/* AUDIO DIAGNOSTICS */}
        <div className="camera-card" style={{ padding: 16 }}>
          <h4 style={{ fontSize: '0.9rem', marginBottom: 12, borderBottom: '1px solid var(--border-color)', paddingBottom: 8 }}>
            🎙️ 麦克风 (Microphone Sensor)
          </h4>
          <div style={{ fontSize: '0.85rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div>状态: <strong>{healthAudio?.status || 'idle'}</strong></div>
            <div>回声消除 (Echo Cancellation): <strong>{audioSettings?.echoCancellation ? '开启' : '已关闭 (Off)'}</strong></div>
            <div>自动增益 (Auto Gain Control): <strong>{audioSettings?.autoGainControl ? '开启' : '已关闭 (Off)'}</strong></div>
            <div>降噪 (Noise Suppression): <strong>{audioSettings?.noiseSuppression ? '开启' : '已关闭 (Off)'}</strong></div>
            <div>
              质量标志: {healthAudio?.qualityFlags.length ? healthAudio.qualityFlags.join(', ') : '正常 (Normal)'}
            </div>
          </div>
        </div>

        {/* MEMORY & TIMING DIAGNOSTICS */}
        <div className="camera-card" style={{ padding: 16 }}>
          <h4 style={{ fontSize: '0.9rem', marginBottom: 12, borderBottom: '1px solid var(--border-color)', paddingBottom: 8 }}>
            ⚡ 性能与单调时间轴 (Performance & Timing)
          </h4>
          <div style={{ fontSize: '0.85rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div>时间轴源: <strong>performance.now() (Monotonic)</strong></div>
            <div>图像处理线程: <strong>Web Worker (Off-Main-Thread)</strong></div>
            <div>内存警示: <strong>正常 (使用 50 帧环形缓冲区)</strong></div>
          </div>
        </div>
      </div>
    </div>
  );
};
